// extracted by mini-css-extract-plugin
module.exports = {"red":"percent_red__LAb0Z","green":"percent_green__d15hc"};